import { useState, useEffect, useCallback } from "react";

const IMAGES = {
  hero:  "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-01.jpeg",
  about: "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-02.jpeg",
};

const GALLERY = [
  "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-01.jpeg",
  "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-02.jpeg",
  "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-03.jpeg",
  "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-04.jpeg",
  "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-05.jpeg",
  "https://dvveuajgmywy3.cloudfront.net/images/1779309754677-sarfaraz-saifi-06.jpeg",
];

const awards = [
  { year: "2024", title: "AMU Old Boys Association Journalist Award", org: "AMU University, Aligarh" },
  { year: "2023", title: "Rashtra Chetna Journalist Award", org: "Brahma Kumaris Global Summit, Mount Abu" },
  { year: "2023", title: "Mahatma Gandhi National Journalist Award", org: "National" },
  { year: "2021", title: "Zee News Media Excellence Award", org: "Best News Anchor – Rashtravaad 9 PM Prime-Time" },
  { year: "2022", title: "Maharashtra Governor Award", org: "Best Ground Reporting/Anchoring (COVID-19)" },
  { year: "2017", title: "Young Media Entrepreneur International Award", org: "Global Investment Summit, Bangkok" },
  { year: "2016", title: "Media Entrepreneur International Award", org: "World Brand Summit, Dubai, UAE" },
  { year: "2014", title: "India's Achievements Award", org: "National Recognition" },
  { year: "2013", title: "Indian Media Youth Icon Award", org: "National" },
  { year: "2012", title: "10th S.P. Singh Media Young Achiever Award", org: "Young VP, Corporate TV Industry" },
  { year: "2010", title: "Rajiv Gandhi Journalist Award", org: "Best News Anchor" },
  { year: "2008", title: "Rajiv Gandhi Global Excellence Award", org: "Best News Anchor" },
  { year: "2007", title: "National Television Journalism Award", org: "Best Crime Reporter" },
];

const skills = [
  "Broadcast Journalism", "Prime-Time Anchoring", "Editorial Leadership",
  "Digital Media Strategy", "Brand Management", "Ground Reporting",
  "Marketing Strategy", "Entrepreneurship", "Production Management",
];

const stats = [
  { value: "23+", label: "Years Experience" },
  { value: "1500+", label: "Episodes Anchored" },
  { value: "13+", label: "Awards Won" },
  { value: "6+", label: "Channels Launched" },
];

// ── Lightbox ──────────────────────────────────────────────────────────────────
function Lightbox({ images, index, onClose, onPrev, onNext }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    }
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  return (
    <div style={S.lbOverlay} onClick={onClose}>
      <button style={S.lbClose} onClick={onClose}>✕</button>
      <button style={{ ...S.lbArrow, left: 20 }} onClick={e => { e.stopPropagation(); onPrev(); }}>‹</button>
      <div style={S.lbImgWrap} onClick={e => e.stopPropagation()}>
        <img src={images[index]} alt={`Gallery ${index + 1}`} style={S.lbImg} />
        <div style={S.lbCounter}>{index + 1} / {images.length}</div>
      </div>
      <button style={{ ...S.lbArrow, right: 20 }} onClick={e => { e.stopPropagation(); onNext(); }}>›</button>
    </div>
  );
}

// ── Gallery Section ───────────────────────────────────────────────────────────
function GallerySection({ images }) {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const open  = (i) => setLightboxIndex(i);
  const close = () => setLightboxIndex(null);
  const prev  = () => setLightboxIndex(i => (i - 1 + images.length) % images.length);
  const next  = () => setLightboxIndex(i => (i + 1) % images.length);

  return (
    <section id="gallery" style={{ ...S.section, background: "linear-gradient(180deg,#070715 0%,#060612 100%)" }}>
      <div style={S.container}>
        <SectionTitle>Gallery</SectionTitle>
        <p style={S.sectionSub}>Behind the lens — moments from the studio, stage, and field.</p>
        <div style={S.galleryGrid}>
          {images.map((src, i) => (
            <div
              key={i}
              style={S.galleryItem}
              className="gallery-item"
              onClick={() => open(i)}
              role="button"
              tabIndex={0}
              onKeyDown={e => e.key === "Enter" && open(i)}
            >
              <img src={src} alt={`Sarfaraz Saifi ${i + 1}`} style={S.galleryImg} loading="lazy" />
              <div style={S.galleryOverlay} className="gallery-overlay">
                <span style={S.galleryZoom}>⊕</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {lightboxIndex !== null && (
        <Lightbox images={images} index={lightboxIndex} onClose={close} onPrev={prev} onNext={next} />
      )}
    </section>
  );
}

// ── Section Title ─────────────────────────────────────────────────────────────
function SectionTitle({ children }) {
  return (
    <div style={{ marginBottom: 48 }}>
      <h2 style={S.sectionTitle}>{children}</h2>
      <div style={S.titleUnderline} />
    </div>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
export default function SarafarazSaifi() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollY, setScrollY]   = useState(0);
  const [visibleAwards, setVisibleAwards] = useState(6);

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { id: "about",   label: "About"   },
    { id: "gallery", label: "Gallery" },
    { id: "awards",  label: "Awards"  },
    { id: "skills",  label: "Skills"  },
    { id: "contact", label: "Contact" },
  ];

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div style={S.root}>
      <style>{css}</style>

      {/* ── NAV ── */}
      <nav style={{
        ...S.nav,
        background: scrollY > 60 ? "rgba(6,6,18,0.97)" : "transparent",
        boxShadow: scrollY > 60 ? "0 2px 32px rgba(0,0,0,0.4)" : "none",
      }}>
        <div style={S.navInner}>
          <span style={S.navLogo}>Sarfaraz <span style={S.accent}>Saifi</span></span>
          <div style={S.navLinks} className="nav-links">
            {navLinks.map(l => (
              <button key={l.id} style={S.navBtn} onClick={() => scrollTo(l.id)} className="nav-btn">
                {l.label}
              </button>
            ))}
          </div>
          <button style={S.hamburger} onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
            <span style={{ ...S.bar, transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none" }} />
            <span style={{ ...S.bar, opacity: menuOpen ? 0 : 1 }} />
            <span style={{ ...S.bar, transform: menuOpen ? "rotate(-45deg) translate(5px,-5px)" : "none" }} />
          </button>
        </div>
        {menuOpen && (
          <div style={S.mobileMenu}>
            {navLinks.map(l => (
              <button key={l.id} style={S.mobileBtn} onClick={() => scrollTo(l.id)}>{l.label}</button>
            ))}
          </div>
        )}
      </nav>

      {/* ── HERO ── */}
      <section id="hero" style={S.hero}>
        <div style={S.heroBg} />
        <div style={S.heroGrid} />
        <div style={S.heroContent}>
          <div style={S.heroLeft}>
            <div style={S.tagline}>✦ PRIME-TIME NEWS ANCHOR</div>
            <h1 style={S.heroName}>
              Sarfaraz<br />
              <span style={S.heroNameAccent}>Saifi</span>
            </h1>
            <p style={S.heroSub}>Veteran Journalist · Media Entrepreneur · PhD Scholar</p>
            <p style={S.heroDesc}>
              A perfect combination of intellect, attitude, and style — with over{" "}
              <strong style={{ color: "#e8b84b" }}>23 years</strong> in broadcast media,
              editorial leadership, and digital strategy.
            </p>
            <div style={S.heroCtas}>
              <button style={S.ctaPrimary} onClick={() => scrollTo("about")} className="cta-btn">
                Explore Profile
              </button>
              <button style={S.ctaSecondary} onClick={() => scrollTo("gallery")} className="cta-btn-sec">
                View Gallery
              </button>
            </div>
            <div style={S.langRow}>
              {["Urdu", "Hindi", "English"].map(l => (
                <span key={l} style={S.langTag}>{l}</span>
              ))}
            </div>
          </div>
          <div style={S.heroRight}>
            <div style={S.photoFrame}>
              <div style={S.photoGlow} />
              <img src={IMAGES.hero} alt="Sarfaraz Saifi" style={S.heroPhoto} />
              <div style={S.photoCornerTL} />
              <div style={S.photoCornerBR} />
            </div>
          </div>
        </div>
        <div style={S.scrollHint} className="scroll-hint">↓ Scroll</div>
      </section>

      {/* ── STATS ── */}
      <section id="stats" style={S.statsSection}>
        <div style={S.statsGrid}>
          {stats.map((s, i) => (
            <div key={i} style={S.statCard} className="stat-card">
              <div style={S.statValue}>{s.value}</div>
              <div style={S.statLabel}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section id="about" style={S.section}>
        <div style={S.container}>
          <SectionTitle>About Me</SectionTitle>
          <div style={S.aboutGrid}>
            <div style={S.aboutImgWrap}>
              <img src={IMAGES.about} alt="Sarfaraz Saifi Studio" style={S.aboutImg} />
              <div style={S.aboutImgOverlay}>
                <span style={S.aboutImgBadge}>राष्ट्र की आवाज़</span>
              </div>
            </div>
            <div style={S.aboutText}>
              <p style={S.para}>
                Mr. Sarfaraz Saifi is a young and dynamic prime-time news anchor and media entrepreneur —
                the driving force behind an ambitious multi-vertical media initiative in the TV news industry.
              </p>
              <p style={S.para}>
                A versatile professional with over{" "}
                <span style={S.highlight}>23 years of hardcore experience</span> in broadcast media,
                spanning editorial leadership, digital media, and management roles.
              </p>
              <p style={S.para}>
                He holds a <span style={S.highlight}>BJMC & MJMC</span> from Aligarh Muslim University,
                a <span style={S.highlight}>PhD in Journalism (Digital Media & Strategy Branding) – 2024</span>,
                and an LLB from Bhagwati Law College, NCR.
              </p>
              <p style={S.para}>
                Mr. Saifi has been part of the launching teams of{" "}
                <span style={S.highlight}>more than half a dozen news channels</span>, serving in top
                leadership positions and consistently proving to be an asset to every organization.
              </p>
              <div style={S.showDetails}>
                <div style={S.showCard}>
                  <div style={S.showName}>राष्ट्रवाद</div>
                  <div style={S.showMeta}>Prime-Time Show · 9 PM</div>
                </div>
                <div style={S.showCard}>
                  <div style={S.showName}>राष्ट्र की आवाज</div>
                  <div style={S.showMeta}>1500+ Episodes</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── GALLERY ── */}
      <GallerySection images={GALLERY} />

      {/* ── AWARDS ── */}
      <section id="awards" style={{ ...S.section, background: "linear-gradient(180deg,#0a0a1f 0%,#070715 100%)" }}>
        <div style={S.container}>
          <SectionTitle>Awards & Recognition</SectionTitle>
          <p style={S.sectionSub}>
            Nationally & internationally recognized for excellence in journalism and media entrepreneurship.
          </p>
          <div style={S.awardsGrid}>
            {awards.slice(0, visibleAwards).map((a, i) => (
              <div key={i} style={S.awardCard} className="award-card">
                <div style={S.awardAccent} />
                <div style={S.awardYear}>{a.year}</div>
                <div style={S.awardTitle}>{a.title}</div>
                <div style={S.awardOrg}>{a.org}</div>
              </div>
            ))}
          </div>
          {visibleAwards < awards.length && (
            <div style={{ textAlign: "center", marginTop: 32 }}>
              <button style={S.ctaPrimary} onClick={() => setVisibleAwards(awards.length)} className="cta-btn">
                Show All {awards.length} Awards
              </button>
            </div>
          )}
        </div>
      </section>

      {/* ── SKILLS ── */}
      <section id="skills" style={S.section}>
        <div style={S.container}>
          <SectionTitle>Expertise</SectionTitle>
          <div style={S.skillsWrap}>
            {skills.map((s, i) => (
              <div key={i} style={S.skillPill} className="skill-pill">{s}</div>
            ))}
          </div>
          <div style={S.eduRow}>
            {[
              { icon: "🎓", title: "BJMC & MJMC", sub: "Aligarh Muslim University" },
              { icon: "📜", title: "PhD – Journalism 2024", sub: "Digital Media & Strategy Branding" },
              { icon: "⚖️", title: "LLB", sub: "Bhagwati Law College, NCR" },
            ].map((e, i) => (
              <div key={i} style={S.eduCard}>
                <div style={S.eduIcon}>{e.icon}</div>
                <div>
                  <div style={S.eduTitle}>{e.title}</div>
                  <div style={S.eduSub}>{e.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section id="contact" style={{ ...S.section, background: "linear-gradient(135deg,#07071a 0%,#0e0e2e 100%)" }}>
        <div style={S.container}>
          <SectionTitle>Connect</SectionTitle>
          <div style={S.contactBox}>
            <div style={S.contactInfo}>
              <p style={S.contactIntro}>
                Veteran journalist, prime-time anchor, media entrepreneur — open for collaborations,
                speaking engagements, and media ventures.
              </p>
              <a
                href="https://www.linkedin.com/in/sarfaraz-saifi-b3326019"
                target="_blank"
                rel="noopener noreferrer"
                style={S.linkedinBtn}
                className="cta-btn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 8 }}>
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
                LinkedIn Profile
              </a>
              <div style={S.locationTag}>📍 Mumbai Metropolitan Region, India</div>
            </div>
            <div style={S.contactQuote}>
              <div style={S.quoteMarks}>"</div>
              <p style={S.quoteText}>A perfect combination of intellect, attitude, and style.</p>
              <div style={S.quoteSource}>— Renowned Media Sources</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={S.footer}>
        <div style={S.footerInner}>
          <span style={S.footerName}>Sarfaraz <span style={S.accent}>Saifi</span></span>
          <span style={S.footerMeta}>Veteran Journalist · 23+ Years · Mumbai</span>
          <span style={S.footerCopy}>© 2024 All Rights Reserved</span>
        </div>
      </footer>
    </div>
  );
}

// ── Styles ────────────────────────────────────────────────────────────────────
const S = {
  root:       { fontFamily: "'Poppins', sans-serif", background: "#060612", color: "#f0f0f5", minHeight: "100vh", overflowX: "hidden" },
  accent:     { color: "#e8b84b" },
  nav:        { position: "fixed", top: 0, left: 0, right: 0, zIndex: 100, transition: "background 0.4s, box-shadow 0.4s", backdropFilter: "blur(8px)" },
  navInner:   { maxWidth: 1200, margin: "0 auto", padding: "0 24px", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between" },
  navLogo:    { fontSize: 20, fontWeight: 700, letterSpacing: "0.04em", color: "#fff" },
  navLinks:   { display: "flex", gap: 4 },
  navBtn:     { background: "none", border: "none", color: "#ccc", fontFamily: "'Poppins',sans-serif", fontSize: 14, fontWeight: 500, cursor: "pointer", padding: "8px 14px", borderRadius: 6, transition: "color 0.2s, background 0.2s" },
  hamburger:  { display: "none", flexDirection: "column", gap: 5, background: "none", border: "none", cursor: "pointer", padding: 4 },
  bar:        { display: "block", width: 24, height: 2, background: "#fff", borderRadius: 2, transition: "all 0.3s" },
  mobileMenu: { background: "rgba(6,6,18,0.98)", padding: "12px 24px 20px", display: "flex", flexDirection: "column", gap: 4 },
  mobileBtn:  { background: "none", border: "none", color: "#ccc", fontFamily: "'Poppins',sans-serif", fontSize: 16, fontWeight: 500, cursor: "pointer", padding: "12px 0", textAlign: "left", borderBottom: "1px solid rgba(255,255,255,0.06)" },
  hero:       { minHeight: "100vh", position: "relative", display: "flex", alignItems: "center", overflow: "hidden" },
  heroBg:     { position: "absolute", inset: 0, background: "radial-gradient(ellipse 80% 60% at 60% 40%, rgba(232,184,75,0.08) 0%, transparent 70%), radial-gradient(ellipse 50% 50% at 20% 80%, rgba(72,52,200,0.15) 0%, transparent 70%), #060612", zIndex: 0 },
  heroGrid:   { position: "absolute", inset: 0, zIndex: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.02) 1px,transparent 1px)", backgroundSize: "60px 60px" },
  heroContent:{ position: "relative", zIndex: 2, maxWidth: 1200, margin: "0 auto", padding: "100px 24px 60px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 48, width: "100%", flexWrap: "wrap" },
  heroLeft:   { flex: "1 1 400px", minWidth: 280 },
  tagline:    { fontSize: 12, fontWeight: 600, letterSpacing: "0.25em", color: "#e8b84b", marginBottom: 16 },
  heroName:   { fontSize: "clamp(52px,8vw,96px)", fontWeight: 800, lineHeight: 1.0, color: "#fff", margin: "0 0 8px", letterSpacing: "-0.02em" },
  heroNameAccent: { color: "#e8b84b", display: "block" },
  heroSub:    { fontSize: 16, color: "#8888aa", fontWeight: 400, margin: "16px 0 20px", letterSpacing: "0.04em" },
  heroDesc:   { fontSize: 15, color: "#bbbbd4", lineHeight: 1.7, maxWidth: 480, margin: "0 0 32px" },
  heroCtas:   { display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 28 },
  ctaPrimary: { background: "linear-gradient(135deg,#e8b84b,#c9942a)", color: "#000", border: "none", borderRadius: 8, padding: "14px 28px", fontFamily: "'Poppins',sans-serif", fontWeight: 700, fontSize: 14, cursor: "pointer", letterSpacing: "0.04em", transition: "transform 0.2s,box-shadow 0.2s" },
  ctaSecondary:{ background: "transparent", color: "#e8b84b", border: "2px solid rgba(232,184,75,0.5)", borderRadius: 8, padding: "12px 28px", fontFamily: "'Poppins',sans-serif", fontWeight: 600, fontSize: 14, cursor: "pointer", letterSpacing: "0.04em", transition: "border-color 0.2s,background 0.2s" },
  langRow:    { display: "flex", gap: 8, flexWrap: "wrap" },
  langTag:    { fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", color: "#888", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 20, padding: "4px 12px" },
  heroRight:  { flex: "0 0 auto", display: "flex", justifyContent: "center" },
  photoFrame: { position: "relative", width: 300, height: 400, borderRadius: 20, overflow: "visible" },
  photoGlow:  { position: "absolute", inset: -20, zIndex: 0, background: "radial-gradient(ellipse,rgba(232,184,75,0.25) 0%,transparent 70%)", borderRadius: 40 },
  heroPhoto:  { width: 300, height: 400, objectFit: "cover", objectPosition: "top center", borderRadius: 20, position: "relative", zIndex: 1, display: "block", border: "2px solid rgba(232,184,75,0.3)" },
  photoCornerTL: { position: "absolute", top: -8, left: -8, width: 40, height: 40, zIndex: 2, borderTop: "3px solid #e8b84b", borderLeft: "3px solid #e8b84b", borderRadius: "8px 0 0 0" },
  photoCornerBR: { position: "absolute", bottom: -8, right: -8, width: 40, height: 40, zIndex: 2, borderBottom: "3px solid #e8b84b", borderRight: "3px solid #e8b84b", borderRadius: "0 0 8px 0" },
  scrollHint: { position: "absolute", bottom: 28, left: "50%", transform: "translateX(-50%)", color: "rgba(255,255,255,0.3)", fontSize: 13, letterSpacing: "0.2em", zIndex: 2, fontWeight: 500 },
  statsSection:{ background: "linear-gradient(90deg,#0d0d28 0%,#0a0a20 100%)", borderTop: "1px solid rgba(232,184,75,0.15)", borderBottom: "1px solid rgba(232,184,75,0.15)", padding: "40px 24px" },
  statsGrid:  { maxWidth: 900, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 24 },
  statCard:   { textAlign: "center", padding: "24px 16px", borderRadius: 12, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(232,184,75,0.1)", transition: "transform 0.2s" },
  statValue:  { fontSize: 44, fontWeight: 800, color: "#e8b84b", lineHeight: 1 },
  statLabel:  { fontSize: 13, color: "#8888aa", fontWeight: 500, marginTop: 8, letterSpacing: "0.04em" },
  section:    { padding: "96px 24px", background: "#060612" },
  container:  { maxWidth: 1100, margin: "0 auto" },
  sectionTitle:{ fontSize: "clamp(28px,4vw,44px)", fontWeight: 800, color: "#fff", margin: 0, letterSpacing: "-0.02em" },
  titleUnderline:{ width: 60, height: 4, background: "linear-gradient(90deg,#e8b84b,#c9942a)", borderRadius: 2, marginTop: 12 },
  sectionSub: { color: "#8888aa", fontSize: 15, maxWidth: 540, margin: "-24px 0 40px" },
  aboutGrid:  { display: "grid", gridTemplateColumns: "1fr 1.6fr", gap: 56, alignItems: "start" },
  aboutImgWrap:{ position: "relative", borderRadius: 16, overflow: "hidden" },
  aboutImg:   { width: "100%", height: 420, objectFit: "cover", objectPosition: "top center", display: "block", borderRadius: 16, filter: "brightness(0.92)" },
  aboutImgOverlay:{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "16px 20px", background: "linear-gradient(transparent,rgba(6,6,18,0.95))" },
  aboutImgBadge:{ fontSize: 18, fontWeight: 700, color: "#e8b84b" },
  aboutText:  {},
  para:       { color: "#bbbbd4", lineHeight: 1.75, marginBottom: 18, fontSize: 15 },
  highlight:  { color: "#e8b84b", fontWeight: 600 },
  showDetails:{ display: "flex", gap: 16, marginTop: 28, flexWrap: "wrap" },
  showCard:   { background: "rgba(232,184,75,0.06)", border: "1px solid rgba(232,184,75,0.2)", borderRadius: 10, padding: "14px 20px", flex: "1 1 140px" },
  showName:   { fontSize: 18, fontWeight: 700, color: "#e8b84b" },
  showMeta:   { fontSize: 12, color: "#8888aa", marginTop: 4 },
  // Gallery
  galleryGrid:{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 },
  galleryItem:{ position: "relative", borderRadius: 12, overflow: "hidden", cursor: "pointer", aspectRatio: "4/3", border: "1px solid rgba(232,184,75,0.1)", transition: "transform 0.25s, border-color 0.25s" },
  galleryImg: { width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center", display: "block", transition: "transform 0.4s" },
  galleryOverlay:{ position: "absolute", inset: 0, background: "rgba(6,6,18,0.55)", display: "flex", alignItems: "center", justifyContent: "center", opacity: 0, transition: "opacity 0.25s" },
  galleryZoom:{ fontSize: 36, color: "#e8b84b", fontWeight: 300, lineHeight: 1 },
  // Lightbox
  lbOverlay:  { position: "fixed", inset: 0, background: "rgba(4,4,16,0.96)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" },
  lbImgWrap:  { position: "relative", maxWidth: "80vw", maxHeight: "85vh" },
  lbImg:      { maxWidth: "80vw", maxHeight: "85vh", objectFit: "contain", borderRadius: 12, display: "block", border: "1px solid rgba(232,184,75,0.2)" },
  lbClose:    { position: "absolute", top: 20, right: 24, background: "none", border: "none", color: "#fff", fontSize: 28, cursor: "pointer", zIndex: 10, lineHeight: 1 },
  lbArrow:    { position: "absolute", top: "50%", transform: "translateY(-50%)", background: "rgba(232,184,75,0.15)", border: "1px solid rgba(232,184,75,0.3)", color: "#e8b84b", fontSize: 40, lineHeight: 1, width: 52, height: 52, borderRadius: "50%", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10, transition: "background 0.2s" },
  lbCounter:  { position: "absolute", bottom: -32, left: "50%", transform: "translateX(-50%)", color: "#8888aa", fontSize: 13, whiteSpace: "nowrap" },
  awardsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 20 },
  awardCard:  { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(232,184,75,0.1)", borderRadius: 12, padding: "24px 22px 24px 26px", position: "relative", overflow: "hidden", transition: "transform 0.2s, border-color 0.2s", cursor: "default" },
  awardAccent:{ position: "absolute", top: 0, left: 0, width: 4, height: "100%", background: "linear-gradient(180deg,#e8b84b,transparent)", borderRadius: "2px 0 0 2px" },
  awardYear:  { fontSize: 11, fontWeight: 700, color: "#e8b84b", letterSpacing: "0.15em", marginBottom: 8 },
  awardTitle: { fontSize: 15, fontWeight: 600, color: "#f0f0f5", marginBottom: 6, lineHeight: 1.4 },
  awardOrg:   { fontSize: 13, color: "#777799", lineHeight: 1.4 },
  skillsWrap: { display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 56 },
  skillPill:  { background: "rgba(232,184,75,0.07)", border: "1px solid rgba(232,184,75,0.25)", color: "#e8b84b", borderRadius: 30, padding: "10px 20px", fontSize: 14, fontWeight: 500, transition: "background 0.2s", cursor: "default" },
  eduRow:     { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(240px,1fr))", gap: 20 },
  eduCard:    { display: "flex", gap: 16, alignItems: "flex-start", background: "rgba(255,255,255,0.03)", borderRadius: 12, padding: "20px", border: "1px solid rgba(255,255,255,0.06)" },
  eduIcon:    { fontSize: 28, lineHeight: 1 },
  eduTitle:   { fontSize: 15, fontWeight: 600, color: "#f0f0f5", marginBottom: 4 },
  eduSub:     { fontSize: 13, color: "#8888aa" },
  contactBox: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "center" },
  contactInfo:{},
  contactIntro:{ color: "#bbbbd4", lineHeight: 1.75, fontSize: 16, marginBottom: 32 },
  linkedinBtn:{ display: "inline-flex", alignItems: "center", background: "linear-gradient(135deg,#e8b84b,#c9942a)", color: "#000", textDecoration: "none", borderRadius: 8, padding: "14px 28px", fontFamily: "'Poppins',sans-serif", fontWeight: 700, fontSize: 14, letterSpacing: "0.04em", marginBottom: 20, transition: "transform 0.2s" },
  locationTag:{ color: "#777799", fontSize: 14, fontWeight: 500 },
  contactQuote:{ background: "rgba(232,184,75,0.04)", border: "1px solid rgba(232,184,75,0.15)", borderRadius: 16, padding: "36px 32px", position: "relative" },
  quoteMarks: { fontSize: 72, color: "#e8b84b", lineHeight: 0.6, marginBottom: 20, fontFamily: "Georgia,serif" },
  quoteText:  { fontSize: 20, fontWeight: 600, color: "#f0f0f5", lineHeight: 1.5, margin: "0 0 20px" },
  quoteSource:{ fontSize: 13, color: "#8888aa", fontWeight: 500, letterSpacing: "0.08em" },
  footer:     { background: "#040410", borderTop: "1px solid rgba(255,255,255,0.05)", padding: "28px 24px" },
  footerInner:{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 },
  footerName: { fontSize: 18, fontWeight: 700, color: "#fff" },
  footerMeta: { fontSize: 13, color: "#666688" },
  footerCopy: { fontSize: 12, color: "#444466" },
};

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { margin: 0; }
  .nav-btn:hover { color: #e8b84b !important; background: rgba(232,184,75,0.08) !important; }
  .cta-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(232,184,75,0.25); }
  .cta-btn-sec:hover { border-color: #e8b84b !important; background: rgba(232,184,75,0.07) !important; }
  .stat-card:hover { transform: translateY(-4px); }
  .award-card:hover { border-color: rgba(232,184,75,0.35) !important; transform: translateY(-2px); }
  .skill-pill:hover { background: rgba(232,184,75,0.14) !important; }
  .gallery-item:hover { transform: scale(1.02); border-color: rgba(232,184,75,0.4) !important; }
  .gallery-item:hover .gallery-overlay { opacity: 1 !important; }
  .gallery-item:hover img { transform: scale(1.06); }
  .scroll-hint { animation: bounce 2s infinite; }
  @keyframes bounce { 0%,100%{transform:translateX(-50%) translateY(0)} 50%{transform:translateX(-50%) translateY(8px)} }
  @media (max-width: 768px) {
    .nav-links { display: none !important; }
    button[aria-label="Menu"] { display: flex !important; }
  }
  @media (min-width: 769px) { button[aria-label="Menu"] { display: none !important; } }
  @media (max-width: 900px) {
    div[style*="1fr 1.6fr"] { grid-template-columns: 1fr !important; }
    div[style*="1fr 1fr"] { grid-template-columns: 1fr !important; }
    div[style*="repeat(3, 1fr)"] { grid-template-columns: repeat(2,1fr) !important; }
  }
  @media (max-width: 500px) {
    div[style*="repeat(3, 1fr)"] { grid-template-columns: 1fr !important; }
  }
`;